import { Injectable } from '@angular/core';

/**
 * Experimental
 */
@Injectable({ providedIn: 'root' })
export class FeaturesDisableAutoLoadService {
  disableAutoLoad = false;
}